package com.cybersoftsolution.cybersoftsolutionweb.use_cases

import com.cybersoftsolution.cybersoftsolutionweb.api.isProductionMode
import com.cybersoftsolution.cybersoftsolutionweb.utils.Utils.isDevelopmentMode
import kotlinx.coroutines.CoroutineScope


suspend fun CoroutineScope.isProductionModeUseCase(): Boolean {

    if (isDevelopmentMode()) {
        return true
    }

    isProductionMode().also { response ->
        console.log(response)
        return response?.data?:false
    }


}